import { Paragraph, Stack, Text } from '@ui'
import type { BotData } from 'use-towns-client'

type Props = {
    bot: BotData | undefined
}

export const AboutTheBot = ({ bot }: Props) => {
    if (!bot?.metadata) {
        return null
    }

    const { motto, description } = bot.metadata

    // Prefer motto if it exists, otherwise use description
    const displayText = motto || description

    if (!displayText) {
        return null
    }

    // Get first two lines (split by newlines and take first 2)
    const lines = displayText.split('\n').filter((line) => line.trim() !== '')
    const twoLines = lines.slice(0, 2).join('\n')

    return (
        <Stack padding gap="paragraph" background="level2" rounded="sm">
            <Text strong>About the Bot</Text>
            <Paragraph color="gray2" style={{ whiteSpace: 'pre-wrap' }}>
                {twoLines}
            </Paragraph>
        </Stack>
    )
}
